<template>
  <div>
    <odontograma-atualizar-atendimento v-if="atendimendoSelecionado" :atendimento="atendimendoSelecionado"
                                       @fecharAtendimentoSelecionado="voltarMenuAtendimentos"
                                       @buscarHistoricoProcedimentos="buscarHistoricoProcedimentos"
    />
    <odontograma-novo-atendimento v-if="modoIniciar" @fecharAtendimento="voltarMenuAtendimentos"
                                  @atendimentoSalvo="selecionarAtendimentoSalvo"/>
    <div v-if="!atendimendoSelecionado && !modoIniciar">
      <v-btn
          class="btn-atendimento-primario"
          color="primary" depressed
          @click="iniciarAtendimento">
        Iniciar novo atendimento
      </v-btn>
      <div class="label-primary-com-borda mt-5"><label>Histórico de atendimentos</label></div>
      <odontograma-atendimento-tabela
          :itens="atendimentoList"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="$store.state.atendimento.resultadoBuscaTodosAtendimentos.paginacao"
          :atendimento-novo="idAtendimentoNovo"
          @acessar="buscarAtendimento"
          @paginar="tratarEventoPaginar"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import {mapMutations} from 'vuex'
import OdontogramaAtendimentoTabela
from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaAtendimentoTabela.vue'
import OdontogramaAtualizarAtendimento
from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaAtualizarAtendimento.vue'
import OdontogramaNovoAtendimento
from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaNovoAtendimento.vue'


export default {
    nome: 'OdontogramaAtendimento',
    components: {OdontogramaNovoAtendimento, OdontogramaAtualizarAtendimento, OdontogramaAtendimentoTabela},
    data() {
        return {
            idPaciente: null,
            idAtendimentoNovo: null,
            atendimentoList: [],
            atendimendoSelecionado: null,
            odontogramaAtendimentoSelecionado: null,
            paginas: 0,
            totalItens: 0,
            filtrosInterno: this.getFiltros(),
            modoIniciar: false
        }
    },
    mounted() {
        this.setarIdPaciente()
    },
    methods: {
        ...mapMutations([
            mutationTypes.ATENDIMENTO.SET_FILTROS_BUSCA_TODOS_ATENDIMENTOS,
            mutationTypes.ATENDIMENTO.SET_PAGINACAO_BUSCA_TODOS_ATENDIMENTOS,
            mutationTypes.ATENDIMENTO.RESETA_PAGE,
        ]),
        iniciarAtendimento() {
            this.modoIniciar = true
            this.$store.commit(mutationTypes.DRAWER.SET_ASIDE, true)
        },
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
                this.filtrosInterno.pacienteId.value = this.idPaciente
            }
        },
        async buscar() {
            this.setFiltrosBuscaTodosAtendimentos(this.getFiltrosInterno())
            await this.buscarAtendimentosPaciente()
        },
        async buscarAtendimentosPaciente() {
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.BUSCAR_ATENDIMENTOS_PACIENTE)
            if (resposta) {
                this.atendimentoList = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        tratarEventoBuscaSimples(busca) {
            this.resetaPage()
            this.filtrosInterno.dentistaId.value = busca.dentistaId.value
            this.buscar()
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.atendimento.resultadoBuscaTodosAtendimentos.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.setPaginacaoBuscaTodosAtendimentos(paginacao)
            this.buscar()
        },
        async buscarAtendimento(atendimentoId) {
            const input = {
                atendimentoId: atendimentoId
            }
            const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.BUSCAR_ATENDIMENTO_POR_ID, input)
            if (resposta) {
                this.$store.commit(mutationTypes.DRAWER.SET_ASIDE, true)
                this.atendimendoSelecionado = resposta
                this.deveAtualizarOdontograma(false)
                this.$emit('atualizarAtendimentoSelecionado', this.atendimendoSelecionado)
            }
        },
        selecionarAtendimentoSalvo(atendimento) {
            this.idAtendimentoNovo = atendimento.id
            this.modoIniciar = false
            this.buscarAtendimento(atendimento.id)
        },
        voltarMenuAtendimentos() {
            this.atendimendoSelecionado = null
            this.deveAtualizarOdontograma(true)
            this.$emit('removerAtendimentoSelecionado')
            this.modoIniciar = false
        },
        deveAtualizarOdontograma(atualizar) {
            this.$store.commit(mutationTypes.ODONTOGRAMA.ATUALIZAR_ODONTOGRAMA, atualizar)
        },
        buscarHistoricoProcedimentos() {
            this.$emit('buscarHistoricoProcedimentos')
        }
    }
}
</script>

<style scoped lang="stylus">

.btn-atendimento-primario
  height 100px !important
  width 100%
  border-radius 10px

.container-header-atendimendo-selecionado
  display flex

.selecionado-label > span
  font-weight bold

.textarea-descricao >>> .v-label
  top 10px !important

.botao-cancelar-edicao:hover
  color orange !important

.container-tamanho-atendimento
  height 460px

</style>